export default "/assets/markers/undeliverable_hover.png"